import { Link } from "react-router-dom";

export default function CTABanner() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
          Ready to Shop Smarter?
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
          Explore thousands of products across 14 categories via the Mulebuy spreadsheet system. Start finding better deals today.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Mulebuy Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <Link
            to="/mulebuy-spreadsheet-guide-2026"
            className="inline-flex items-center gap-2 px-8 py-3.5 border border-foreground-300 text-foreground-700 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line"></i>
            Read the Guide
          </Link>
        </div>
      </div>

      <div className="mt-14 max-w-5xl mx-auto">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20elegant%20beige%20leather%20handbag%20placed%20on%20a%20white%20marble%20pedestal%20against%20a%20soft%20peach%20colored%20backdrop%2C%20studio%20lighting%2C%20luxury%20product%20photography%2C%20warm%20ivory%20and%20blush%20tones%2C%20clean%20isolated%20composition&width=300&height=300&seq=float-prod-1-v4&orientation=squarish"
              alt="Mulebuy Spreadsheet Product"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20pair%20of%20classic%20white%20leather%20sneakers%20photographed%20from%20above%20on%20textured%20grey%20concrete%2C%20dramatic%20side%20lighting%2C%20minimalist%20sneaker%20culture%20aesthetic%2C%20crisp%20white%20and%20cool%20grey%20tones%2C%20editorial%20footwear%20photography&width=300&height=300&seq=float-prod-2-v4&orientation=squarish"
              alt="Mulebuy Spreadsheet Product"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20luxurious%20cashmere%20scarf%20in%20deep%20burgundy%20color%20draped%20elegantly%20over%20a%20brass%20stand%2C%20soft%20directional%20light%2C%20refined%20luxury%20accessory%20photography%2C%20rich%20wine%20and%20gold%20tones%2C%20sophisticated%20still%20life&width=300&height=300&seq=float-prod-3-v4&orientation=squarish"
              alt="Mulebuy Spreadsheet Product"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20pair%20of%20round%20tortoiseshell%20sunglasses%20resting%20on%20a%20piece%20of%20raw%20driftwood%2C%20bright%20beachside%20lighting%2C%20effortless%20summer%20aesthetic%2C%20warm%20amber%20and%20sand%20tones%2C%20lifestyle%20product%20photography&width=300&height=300&seq=float-prod-4-v4&orientation=squarish"
              alt="Mulebuy Spreadsheet Product"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20elegant%20silver%20wristwatch%20with%20a%20minimalist%20white%20face%20placed%20on%20a%20dark%20slate%20surface%2C%20precise%20studio%20lighting%20with%20soft%20reflections%2C%20luxury%20timepiece%20photography%2C%20cool%20silver%20and%20charcoal%20tones%2C%20sophisticated%20detail%20shot&width=300&height=300&seq=float-prod-5-v4&orientation=squarish"
              alt="Mulebuy Spreadsheet Product"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}